import { ageAt } from "../../../shared/iin.ts";

export function fmtDate(iso?: string, tz?: string): string {
  if (!iso) return "";
  return new Intl.DateTimeFormat("ru-RU", { timeZone: tz, day: "2-digit", month: "2-digit", year: "numeric" }).format(new Date(iso.length === 10 ? `${iso}T12:00:00Z` : iso));
}

export function fmtTime(iso?: string, tz?: string): string {
  if (!iso) return "";
  return new Intl.DateTimeFormat("ru-RU", { timeZone: tz, hour: "2-digit", minute: "2-digit" }).format(new Date(iso));
}

export function fmtDateTime(iso?: string, tz?: string): string {
  if (!iso) return "";
  return `${fmtDate(iso, tz)} ${fmtTime(iso, tz)}`;
}

export function fmtDuration(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const mm = String(m).padStart(2, "0");
  const ss = String(sec).padStart(2, "0");
  return h ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}

export function ageLabel(birthDate?: string): string {
  if (!birthDate) return "";
  const { years, days } = ageAt(birthDate);
  if (years >= 1) {
    const n = years % 100;
    const w = n % 10 === 1 && n !== 11 ? "год" : [2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n) ? "года" : "лет";
    return `${years} ${w}`;
  }
  if (days < 31) return `${days} дн.`;
  return `${Math.floor(days / 30)} мес.`;
}

export function todayIn(tz?: string): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
}

export function daysAgo(n: number, tz?: string): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(Date.now() - n * 86_400_000));
}

export const pct = (v: number | null | undefined) => (v === null || v === undefined ? "—" : `${Math.round(v * 100)}%`);

export function plural(n: number, one: string, few: string, many: string): string {
  const m = n % 100;
  if (m % 10 === 1 && m !== 11) return one;
  if ([2, 3, 4].includes(m % 10) && ![12, 13, 14].includes(m)) return few;
  return many;
}
